<script>
import { mapState } from "vuex";
import {EF_TRACKING_URL} from "@/paths/constants";

export default {
  props: {
    prepare: {
      type: Boolean,
      default: false,
    },
    customProps: {
      type: Object,
      default: () => ({}),
    }
  },

  data() {
    return {
      loading: null,
      birthDate: "",
      age_num: "",
      dob_year: "",
      dob_month: "",
      dob_day: "",
      birthDateErrorMsg: "",
      currentDate: new Date().toJSON().slice(0, 10).replace(/-/g, "-"),

      dayEntered: "",
      dayError: false,
      emptyDayError: false,
      invalidDayError: false,
      yearEntered: "",
      yearError: false,
      emptyYearError: false,
      invalidYearError: false,
      underAgeError: false,
      monthError: false,
      emptyMonthError: false,
      selectedMonth: "0",
      months: [
        { value: 0, name: "Select month", disabled: true },
        { value: 1, name: "January" },
        { value: 2, name: "February" },
        { value: 3, name: "March" },
        { value: 4, name: "April" },
        { value: 5, name: "May" },
        { value: 6, name: "June" },
        { value: 7, name: "July" },
        { value: 8, name: "August" },
        { value: 9, name: "September" },
        { value: 10, name: "October" },
        { value: 11, name: "November" },
        { value: 12, name: "December" },
      ],
    };
  },

  computed: {
    ...mapState([
      "fields",
      "fieldsFromUrl",
      "fieldsFromStorage"
      ]),
  },

  created() {
    this.validRegex = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/
    if (this.prepare) {
      if(this.fieldsFromUrl["birthdate"]) {
        this.birthDate = this.fieldsFromUrl["birthdate"];
      } else if (this.fieldsFromStorage["birthdate"]) {
        this.birthDate = this.fieldsFromStorage["birthdate"];
      }

      this.setDob();
      const valid = this.validateURL();
      if (!valid) {
        this.$emit("show-this-step");
      } else {
        this.setAnswersAndGoToNext();
      }
    } else {
      let date = new Date();
      this.currentYear = date.getFullYear();
    }
  },

  methods: {
    async setAnswer(answer) {
      this.loading = null;
      const valid = this.validate();
      if (!valid) return;
      this.loading = answer;

      this.setAnswersAndGoToNext();
      // await this.progressionTracking();
    },

    setAnswersAndGoToNext() {
      this.$store.commit('SET_AGE_OF_USER', {optionalYear: this.dob_year})
      this.$store.dispatch("setAnswers", [
        {
          field: "birthdate",
          value: this.birthDate,
        },
        {
          field: "dob_day",
          value: this.dob_day,
        },
        {
          field: "dob_month",
          value: this.dob_month,
        },
        {
          field: "dob_year",
          value: this.dob_year,
        },
      ]);
      this.$emit("next-step");
    },

    validateURL() {
      return this.validRegex.test(String(this.birthDate));
    },

    validate() {
      this.birthDate = this.yearEntered + "-" +  ("0" + this.selectedMonth).slice(-2) + "-" + ("0" + this.dayEntered).slice(-2);
      const valid = this.validRegex.test(String(this.birthDate));
      const validDay = this.validateDay();
      const validYear = this.validateYear();
      const validMonth = this.validateMonth();
      this.setDob();

      if (
        !this.birthDate ||
        this.birthDate.length === 0 ||
        !valid ||
        !validDay ||
        !validYear ||
        !validMonth
      ) {
        return false;
      } else {
        return true;
      }
    },

    validateMonth() {
      if (this.selectedMonth == 0) {
        this.monthError = true;
        this.emptyMonthError = true;
        return false;
      } else {
        return true;
      }
    },

    validateDay() {
      if (!this.dayEntered || this.dayEntered.length === 0) {
        this.dayError = true;
        this.emptyDayError = true;
        return false;
      } else if (!(this.dayEntered >= 1 && this.dayEntered <= 31)) {
        this.dayError = true;
        this.invalidDayError = true;
      } else {
        return true;
      }
    },

    validateYear() {
      let date = new Date();
      let year = date.getFullYear();

      if (!this.yearEntered || this.yearEntered.length === 0) {
        this.yearError = true;
        this.emptyYearError = true;
        return false;
      } else if (
        (this.age_num = year - parseInt(this.birthDate.slice(0, 4))) < 18
      ) {
        this.yearError = true;
        this.underAgeError = true;
        return false;
      } else if (
        !(this.yearEntered >= 1900 && this.yearEntered < this.currentYear)
      ) {
        this.yearError = true;
        this.invalidYearError = true;
      } else {
        return true;
      }
    },

    setDob() {
      if (this.birthDate) {
        this.dob_year = this.birthDate.slice(0, 4);
        this.dob_month = String(this.birthDate.slice(5, 7)).padStart(2, '0');
        this.dob_day = String(this.birthDate.slice(8, 10)).padStart(2, '0');
      }
    },

    handleMonthChange() {
      this.monthError = false;
      this.emptyMonthError = false;
    },

    handleDayChange(dayEntered) {
      this.dayError = false;
      this.emptyDayError = false;
      this.invalidDayError = false;

      this.$nextTick(() => {
        this.dayEntered = parseInt(dayEntered.toString().substr(0, 2));
        if (this.dayEntered > 31) {
          this.dayEntered = 31;
        }

        if (this.dayEntered === 0) {
          this.dayEntered = parseInt(dayEntered.toString().substring(1));
        }
      });
    },

    async progressionTracking() {
      const eventID = this.customProps.trackProgress ? "41" : "61"
      await this.axios.post(`${EF_TRACKING_URL}&event_id=${eventID}&transaction_id=${this.fields['transaction_id']}`)
    },

    handleYearChange(yearEntered) {
      this.yearError = false;
      this.emptyYearError = false;
      this.underAgeError = false;
      this.invalidYearError = false;

      this.$nextTick(() => {
        this.yearEntered = parseInt(yearEntered.toString().substr(0, 4));

        if (this.yearEntered <= 0) this.yearEntered = '';
      });
    },
  },
};
</script>

<template>
  <div v-if="!prepare">
    <div class="container is-max-widescreen px-5">
      <div class="has-text-centered item-box">
        <h2 class="question mb-3">What is your Birthdate? 🎂</h2>
        <form
          class="container is-max-widescreen has-text-left"
          @submit.prevent="setAnswer('Continue')"
        >
          <div class="item-box is-flex is-justify-content-center birthDateContainer mt-4">
            <b-field class="ml-3 month" :type="monthError ? 'is-danger' : ''">
              <b-select
                placeholder="Month"
                required
                v-model="selectedMonth"
                @input="handleMonthChange"
              >
                <option
                  v-for="month in months"
                  :key="month.value"
                  :disabled="month.disabled"
                  :value="month.value"
                >
                  {{ month.name }}
                </option>
              </b-select>
            </b-field>
            <b-field class="ml-3 day" :type="dayError ? 'is-danger' : ''">
              <b-input
                placeholder="Day"
                type="number"
                v-model.trim="dayEntered"
                @input="handleDayChange"
                min="0"
                max="31"
              >
              </b-input>
            </b-field>
            <b-field class="ml-3 year" :type="yearError ? 'is-danger' : ''">
              <b-input
                placeholder="Year"
                type="number"
                v-model.trim="yearEntered"
                @input="handleYearChange"
              >
              </b-input>
            </b-field>
          </div>
          <b-field
            class="birthDateErrors"
            type="is-danger"
            :message="[
              { 'Please select a month.': emptyMonthError },
              { 'Please enter a day.': emptyDayError },
              { 'Day must be between 1 - 31.': invalidDayError },
              { 'Please enter a year.': emptyYearError },
              { 'Your age is Invalid.': underAgeError },
              { [`Year must be between 1900 - ${currentYear}.`]: invalidYearError, },
            ]"
          >
          </b-field>
          <input
            type="submit"
            value="Continue"
            class="submitButton mt-2"
            :loading="loading === 'Continue'"
            :disabled="loading !== null"
          />
        </form>
      </div>
    </div>
  </div>
</template>
